import { Injectable } from '@angular/core';
import { IMPERSONATION_CONSTANTS } from './impersonation.constants';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationConfigService {
  static isImpersonating(clientId: string): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const targetUserIdParam = urlParams.get(IMPERSONATION_CONSTANTS.TARGET_USER_ID_KEY);
    const isImpersonating = urlParams.get(IMPERSONATION_CONSTANTS.IMPERSONATION_FLAG_KEY);
    const hasUrlImpersonationParams = !!targetUserIdParam && isImpersonating === 'true';

    const hasLocalStorageImpersonationData =
      !!localStorage.getItem(IMPERSONATION_CONSTANTS.TARGET_USER_ID_KEY) &&
      localStorage.getItem(IMPERSONATION_CONSTANTS.IMPERSONATION_FLAG_KEY) === 'true';

    if (hasUrlImpersonationParams) {
      this.clearOidcTokensByClientId(clientId);
      this.saveImpersonationData(targetUserIdParam!);
      this.cleanupUrlParams(urlParams);
    }

    return hasUrlImpersonationParams || hasLocalStorageImpersonationData;
  }

  static mergeImpersonationScopes(existingScope: string): string {
    const existingScopes = this.parseScopeString(existingScope);
    const requiredScopes = this.parseScopeString(IMPERSONATION_CONSTANTS.IMPERSONATION_SCOPES);
    const scopesToAdd = requiredScopes.filter(scope => !existingScopes.includes(scope));

    return [...existingScopes, ...scopesToAdd].join(' ');
  }

  private static parseScopeString(scope: string): string[] {
    return scope.split(' ').filter(s => s.trim() !== '');
  }

  private static clearOidcTokensByClientId(clientId: string): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.includes(clientId)) {
        localStorage.removeItem(key);
      }
    }
  }

  private static saveImpersonationData(targetUserId: string): void {
    localStorage.setItem(IMPERSONATION_CONSTANTS.TARGET_USER_ID_KEY, targetUserId);
    localStorage.setItem(IMPERSONATION_CONSTANTS.IMPERSONATION_FLAG_KEY, 'true');
    localStorage.removeItem(IMPERSONATION_CONSTANTS.IMPERSONATION_HISTORY_ID);
  }

  private static cleanupUrlParams(urlParams: URLSearchParams): void {
    urlParams.delete(IMPERSONATION_CONSTANTS.TARGET_USER_ID_KEY);
    urlParams.delete(IMPERSONATION_CONSTANTS.IMPERSONATION_FLAG_KEY);

    const queryString = urlParams.toString();
    const newUrl = window.location.pathname + (queryString ? '?' + queryString : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }
}
